import styles from './RandomCheckmark.module.scss';

export function RandomCheckmark() {
    return <img className={styles.randomTotals} />
}